import { gql } from "@apollo/client";

export const FAQ_R = gql`
    query FAQ ($culture: String!){
    faqTopic (where: {localization: {culture: $culture}}, orderBy: {createdUtc: ASC}){
        contentItemId
        displayText
        icon
        items {
            contentItems {
                __typename
                ... on FaqItem {
                    displayText
                    answer {
                        html
                    }
                }
            }
        }
    }
}
`;